<form [formGroup]="specialIdentifiersForm" class="form-grid">
  <div class="form-column">
    <h3>{{ "admin.tools.form.headings.specialIdentifiers" | translate }}</h3>
<app-input-switch
        [formControl]="specialIdentifiersForm.controls['isToolLifeMonitoredInSap']"
        onLabel="{{ 'admin.tools.form.labels.lifeSAP' | translate }}">
    </app-input-switch>
    <app-input-switch
        [formControl]="specialIdentifiersForm.controls['isToolLifeMonitoredInMes']"
        onLabel="{{ 'admin.tools.form.labels.lifeMES' | translate }}">
    </app-input-switch>
    <app-input-switch
        [formControl]="specialIdentifiersForm.controls['isToolLifeMonitoredInPlc']"
        onLabel="{{ 'admin.tools.form.labels.lifePLC' | translate }}">
    </app-input-switch>
    <app-input-switch
        [formControl]="specialIdentifiersForm.controls['hasMaintenaceAtLine']"
        onLabel="{{ 'admin.tools.form.labels.hasMaintenaceAtLine' | translate }}">
    </app-input-switch>
    <app-input-switch
        [formControl]="specialIdentifiersForm.controls['excludedFromMaintenance']"
        onLabel="{{ 'admin.tools.form.labels.excludedFromMaintenance' | translate }}">
    </app-input-switch>
    <app-input-switch
        [formControl]="specialIdentifiersForm.controls['isToolStationedAtERSA']"
        onLabel="{{ 'admin.tools.form.labels.isToolStationedAtERSA' | translate }}"
        (inputChange)="onToolStationedAtERSAChanged($event)">
    </app-input-switch>
    <app-input-switch
        [formControl]="specialIdentifiersForm.controls['excludedFromReturn']"
        onLabel="{{ 'admin.tools.form.labels.excludedFromReturn' | translate }}"
        (inputChange)="onToolExcludedFromReturnChanged($event)">
    </app-input-switch>
  </div>
  <div class="form-column">
    <div>
        <h3>{{ "admin.tools.form.headings.documentationIdentifiers" | translate }}</h3>
        <div class="documentation-subtitle">{{ "admin.tools.form.headings.isToolInDirectContactWithPCB" | translate }}</div>
    </div>
    <app-input-switch
        [formControl]="specialIdentifiersForm.controls['directContactWithPCB']"
        [onLabel]="'admin.tools.form.labels.directContactWithPCB' | translate"
        (inputChange)="onToolDirectContactWithPCBChanged($event)">
    </app-input-switch>
    <app-input-switch
        [formControl]="specialIdentifiersForm.controls['manualHandling']"
        [onLabel]="'admin.tools.form.labels.manualHandling' | translate"
        (inputChange)="onToolManualHandlingChanged($event)">
    </app-input-switch>
  </div>
</form>
